import { startTransition, useEffect, useState } from "react";

/**
 * from https://github.com/robinjonsson/react-use-sticky
 */
export function useSticky<T extends HTMLElement>(
  stickyRef: React.RefObject<T | undefined>,
  offset?: number
): boolean {
  const [sticky, setSticky] = useState(false);

  useEffect(() => {
    function observe() {
      if (!stickyRef.current) return;
      const refPageOffset = Math.floor(
        stickyRef.current.getBoundingClientRect().top
      );
      const stickyOffset = Math.ceil(
        parseInt(getComputedStyle(stickyRef.current).top) + (offset || 0)
      );

      const stickyActive = refPageOffset <= stickyOffset;

      if (stickyActive && !sticky) startTransition(() => setSticky(true));
      else if (!stickyActive && sticky) startTransition(() => setSticky(false));
    }
    observe();

    // Bind events
    document.addEventListener("scroll", observe);
    window.addEventListener("resize", observe);
    window.addEventListener("orientationchange", observe);

    return () => {
      document.removeEventListener("scroll", observe);
      window.removeEventListener("resize", observe);
      window.removeEventListener("orientationchange", observe);
    };
  }, [offset, sticky, stickyRef]);

  return sticky;
}
